Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    // Minor units by currency (fallback 2)
    var MINOR_UNITS = {
        JPY: 0, KRW: 0, VND: 0, CLP: 0, XOF: 0, XAF: 0, XPF: 0, HUF: 0, RWF: 0, UGX: 0,
        BIF: 0, DJF: 0, GNF: 0, KMF: 0, PYG: 0, VUV: 0,
        BHD: 3, IQD: 3, JOD: 3, KWD: 3, LYD: 3, OMR: 3, TND: 3, MGA: 1
    };

    function getCurrency() {
        if (window.shopSettings && window.shopSettings.currency) return window.shopSettings.currency;
        if (window.Shopify && Shopify.currency && (Shopify.currency.active || Shopify.currency)) {
            return Shopify.currency.active || Shopify.currency;
        }
        return 'USD';
    }

    function getFractionDigits(code) {
        code = (code || '').toString().toUpperCase();
        return Object.prototype.hasOwnProperty.call(MINOR_UNITS, code) ? MINOR_UNITS[code] : 2;
    }

    function toMajor(minor, currency) {
        var digits = getFractionDigits(currency);
        if (digits === 0) return Number(minor);
        return Number(minor) / Math.pow(10, digits);
    }

    function formatWithIntl(minor, precision, separators) {
        var currency = getCurrency();
        var digits = getFractionDigits(currency);
        // keep at most the currency's fraction digits
        var finalPrecision = Math.min(defaultOption(precision, digits), digits);
        var major = toMajor(minor, currency);

        // Use en-US for deterministic "," thousands and "." decimal, then swap if needed
        var nf = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: finalPrecision,
            maximumFractionDigits: finalPrecision,
            useGrouping: true
        });
        var out = nf.format(major);
        if (separators && (separators.thousands || separators.decimal)) {
            var thousands = defaultOption(separators.thousands, ',');
            var decimal = defaultOption(separators.decimal, '.');
            if (thousands !== ',' || decimal !== '.') {
                out = out.replace(/,/g, '__TMP__').replace(/\./g, decimal).replace(/__TMP__/g, thousands);
            }
        }
        return out;
    }

    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
        case 'amount':
            value = formatWithIntl(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithIntl(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithIntl(cents, 2, { thousands: '.', decimal: ',' });
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithIntl(cents, 0, { thousands: '.', decimal: ',' });
            break;
        default:
            value = formatWithIntl(cents, getFractionDigits(getCurrency()));
            break;
    }
    return formatString.replace(placeholderRegex, value);
};